import React from 'react';
import DatabasePageView from './DatabasePage-view';

const DatabasePage = () => {
  return (
    <DatabasePageView
    />
  )
};

DatabasePage.propTypes = {};

export default DatabasePage;

